import React, { useContext, useState } from "react";
import "./ExamCard.css";
import MDSpinner from "react-md-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import formatDateString from "../../../../Util/functions/FormatDateString";
import getIconFromCategoryString from "../../../../Util/functions/getIconFromCategoryString";
import { AppContext } from "../../../../Util/contexts/AppContext";
import { getClientTimezoneName, getClientTimezoneOffset } from "../../../../Util/functions/TimeZone";
const PremadeExamCard = ({
  examData,
  selectedExamId,
  setSelectedExamId,
  examListView,
}) => {
  const {
    userData,
    primaryColor,
    handleViewPreviousExamCompletions,
    fetchMarkReviewLater,
    reviewLaterExams,
  } = useContext(AppContext);

  const [fetchingReviewLater, setFetchingReviewLater] = useState(false);

  const {
    ExamId,
    examNumber,
    ExamTitle,
    ExamName,
    Completed,
    MostRecentCompletionDate,
    MostRecentCompletionScore,
    sections,
    LastCompletionDate,
  } = examData;

  const { AnimationsDisabled } = userData;

  const isExamSelected = selectedExamId === ExamId;

  const handleReviewLaterClick = async (e) => {
    e.stopPropagation();
    setFetchingReviewLater(true);
    const newValue = reviewLaterExams[ExamId] ? false : true;
    await fetchMarkReviewLater(ExamId, null, newValue);
    setFetchingReviewLater(false);
  };

  const handleViewGrades = (e) => {
    e.stopPropagation();
    handleViewPreviousExamCompletions(ExamId);
  };

  return (
    <motion.div
      initial={AnimationsDisabled ? false : { opacity: 0 }}
      animate={AnimationsDisabled ? false : { opacity: 1 }}
      exit={AnimationsDisabled ? false : { opacity: 0 }}
      id={`exam-${ExamId}`}
      className={`caseListCaseContainer${
        isExamSelected ? " caseListCaseSelected" : ""
      }`}
      onClick={() => setSelectedExamId(ExamId)}
      key={`${ExamTitle || ExamName} - ${ExamId}`}
    >
      {Completed && (
        <>
          <div className="caseListCompletedCaseMarkerWrapper">
            <div
              className={
                isExamSelected
                  ? "caseListCompletedCaseMarkerBlueSelected"
                  : "caseListCompletedCaseMarkerBlue"
              }
            />
          </div>
          <div className="caseListCompletedCaseMarkerWrapper">
            <div
              className={
                isExamSelected
                  ? "caseListCompletedCaseMarkerOrangeSelected"
                  : "caseListCompletedCaseMarkerOrange"
              }
            />
          </div>
        </>
      )}
      <div className="caseListCaseHeaderWrapper">
        <h2 className="caseListCaseId">{examNumber}</h2>
        <h3 className="caseListCaseTitle">{ExamTitle || ExamName}</h3>
        <h4 className="caseListCaseMeta">
          Exam Id {ExamId}
          {Completed &&
            ` | Completed: ${formatDateString(
              MostRecentCompletionDate,

              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )} (${Math.floor(MostRecentCompletionScore * 100) / 100}%)`}
        </h4>
      </div>

      <div className="caseListCaseBodyWrapper">
        {sections.map((section, index) => (
          <div
            className="caseListCaseSectionWrapper"
            key={`${ExamId} - ${section.sectionId}`}
          >
            <FontAwesomeIcon
              icon={getIconFromCategoryString(section.sectionCategory)}
              className="caseListCaseSectionIcon"
            />
            <p className="caseListCaseSectionText">
              Section {section.sectionNumber} - {section.sectionTitle}
            </p>
          </div>
        ))}
      </div>

      <div
        className={`caseListCaseFooterContainer${
          isExamSelected ? " caseListCaseFooterSelected" : ""
        }`}
      >
        <div className="caseListCaseFooterReviewLaterContainer">
          {fetchingReviewLater ? (
            <MDSpinner
              size={20}
              singleColor={isExamSelected ? "#fff" : primaryColor}
            />
          ) : (
            <div className="checkboxContainer" onClick={handleReviewLaterClick}>
              {reviewLaterExams[ExamId] && (
                <FontAwesomeIcon icon={faCheck} className="checkboxCheck" />
              )}
            </div>
          )}
          <p
            className={`caseListCaseReviewLaterText ${
              isExamSelected ? "caseListCaseReviewLaterTextSelected" : ""
            }`}
          >
            Review Later
          </p>
        </div>
        {Completed && LastCompletionDate !== "0001-01-01T00:00:00" && (
          <button
            className="caseListCaseButton secondaryButton"
            onClick={handleViewGrades}
          >
            View Grades
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default PremadeExamCard;
